/* tslint:disable */
/* eslint-disable */
/**
 * @export
 * @enum {string}
 */
export var PullRequestAssignmentSettingsTypeEnum;
(function (PullRequestAssignmentSettingsTypeEnum) {
    PullRequestAssignmentSettingsTypeEnum["Auto"] = "auto";
    PullRequestAssignmentSettingsTypeEnum["Manual"] = "manual";
})(PullRequestAssignmentSettingsTypeEnum || (PullRequestAssignmentSettingsTypeEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var PullRequestsSettingsPolicyEnum;
(function (PullRequestsSettingsPolicyEnum) {
    PullRequestsSettingsPolicyEnum["All"] = "all";
    PullRequestsSettingsPolicyEnum["OnlyNew"] = "only_new";
})(PullRequestsSettingsPolicyEnum || (PullRequestsSettingsPolicyEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var PullRequestsSettingsSeverityThresholdEnum;
(function (PullRequestsSettingsSeverityThresholdEnum) {
    PullRequestsSettingsSeverityThresholdEnum["Low"] = "low";
    PullRequestsSettingsSeverityThresholdEnum["Medium"] = "medium";
    PullRequestsSettingsSeverityThresholdEnum["High"] = "high";
    PullRequestsSettingsSeverityThresholdEnum["Critical"] = "critical";
})(PullRequestsSettingsSeverityThresholdEnum || (PullRequestsSettingsSeverityThresholdEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var RecurringTestsSettingsFrequencyEnum;
(function (RecurringTestsSettingsFrequencyEnum) {
    RecurringTestsSettingsFrequencyEnum["Daily"] = "daily";
    RecurringTestsSettingsFrequencyEnum["Weekly"] = "weekly";
    RecurringTestsSettingsFrequencyEnum["Never"] = "never";
})(RecurringTestsSettingsFrequencyEnum || (RecurringTestsSettingsFrequencyEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var ProjectAttributesBusinessCriticalityEnum;
(function (ProjectAttributesBusinessCriticalityEnum) {
    ProjectAttributesBusinessCriticalityEnum["Critical"] = "critical";
    ProjectAttributesBusinessCriticalityEnum["High"] = "high";
    ProjectAttributesBusinessCriticalityEnum["Medium"] = "medium";
    ProjectAttributesBusinessCriticalityEnum["Low"] = "low";
})(ProjectAttributesBusinessCriticalityEnum || (ProjectAttributesBusinessCriticalityEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var ProjectAttributesEnvironmentEnum;
(function (ProjectAttributesEnvironmentEnum) {
    ProjectAttributesEnvironmentEnum["Frontend"] = "frontend";
    ProjectAttributesEnvironmentEnum["Backend"] = "backend";
    ProjectAttributesEnvironmentEnum["Internal"] = "internal";
    ProjectAttributesEnvironmentEnum["External"] = "external";
    ProjectAttributesEnvironmentEnum["Mobile"] = "mobile";
    ProjectAttributesEnvironmentEnum["Saas"] = "saas";
    ProjectAttributesEnvironmentEnum["Onprem"] = "onprem";
    ProjectAttributesEnvironmentEnum["Hosted"] = "hosted";
    ProjectAttributesEnvironmentEnum["Distributed"] = "distributed";
})(ProjectAttributesEnvironmentEnum || (ProjectAttributesEnvironmentEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var ProjectAttributesLifecycleEnum;
(function (ProjectAttributesLifecycleEnum) {
    ProjectAttributesLifecycleEnum["Production"] = "production";
    ProjectAttributesLifecycleEnum["Development"] = "development";
    ProjectAttributesLifecycleEnum["Sandbox"] = "sandbox";
})(ProjectAttributesLifecycleEnum || (ProjectAttributesLifecycleEnum = {}));
/**
 * @export
 * @enum {string}
 */
export var ProjectAttributesStatusEnum;
(function (ProjectAttributesStatusEnum) {
    ProjectAttributesStatusEnum["Active"] = "active";
    ProjectAttributesStatusEnum["Inactive"] = "inactive";
})(ProjectAttributesStatusEnum || (ProjectAttributesStatusEnum = {}));
//# sourceMappingURL=projectsTypes.js.map